import { createFileRoute } from "@tanstack/react-router";

import NoShowBookingsPage from "@/admin/no-show-bookings/page";

export const Route = createFileRoute("/app/$storeId/no-show-bookings")({
    component: RouteComponent,
});

function RouteComponent() {
    return <NoShowBookingsPage />;
}
